import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { getAvailableMonths, fullMonths } from '../../../../helpers/localization/localizationUtils';
import Row from '../../../elements/Row';
import Col from '../../../elements/Col';
import Box from '../../../elements/Box';

function MonthNavigationTabs(props) {
  const {
    onSelect,
    currentMonth,
    fromMonth,
    month,
    year,
    currentMonthSettings,
    months,
    boxItem,
    showShortMonths,
    showYearBeforeMonth,
    colMonthSettings,
    showYear,
    showMonth
  } = props;
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const monthsLabels = fullMonths(translate, localizationData);
  const availableMonths = getAvailableMonths(
    months,
    translate,
    localizationData,
    showShortMonths,
    dayjs(fromMonth)
  );
  const keyPress = { ENTER: 13 };
  let currentProps = {};

  function onKeyDown(event, item) {
    switch (event.keyCode) {
      case keyPress.ENTER:
        onSelect(item);
        break;
      default:
        break;
    }
  }

  return (
    <Row className={className} style={style}>
      {availableMonths.map((item) => {
        currentProps = {};
        const activeMonth = currentMonth.getMonth() === item.number;
        if (activeMonth) {
          currentProps = currentMonthSettings;
        } else {
          currentProps = props;
        }
        return (
          <Col key={item.name} {...colMonthSettings}>
            <Box
              {...boxItem}
              {...currentProps}
              ariaLabel={`${showYearBeforeMonth && showYear ? item.year : ''} ${
                showMonth ? monthsLabels[item.number] : ''
              } ${!showYearBeforeMonth && showYear ? item.year : ''}`}
              onClick={() => !activeMonth && onSelect(item)}
              onKeyDown={(event) => !activeMonth && onKeyDown(event, item)}
            >
              {showYear && showYearBeforeMonth && (
                <Box ariaHidden {...year}>
                  {item.year}
                </Box>
              )}
              {showMonth && (
                <Box ariaHidden {...month}>
                  {item.name}
                </Box>
              )}
              {showYear && !showYearBeforeMonth && (
                <Box ariaHidden {...year}>
                  {item.year}
                </Box>
              )}
            </Box>
          </Col>
        );
      })}
    </Row>
  );
  // }
}
MonthNavigationTabs.propTypes = {
  /**
   * Months to show
   */
  months: PropTypes.number,
  /**
   * Function fire when change month
   */
  onSelect: PropTypes.func,
  /**
   * Current selected month
   */
  currentMonth: PropTypes.instanceOf(Date),
  /**
   * Setting prop for month component
   */
  month: PropTypes.objectOf(PropTypes.any),
  /**
   * Setting prop for year component
   */
  year: PropTypes.objectOf(PropTypes.any),
  /**
   * Active month settings
   */
  currentMonthSettings: PropTypes.objectOf(PropTypes.any),
  /**
   * Column month settings
   */
  colMonthSettings: PropTypes.objectOf(PropTypes.any),
  /**
   * Setting applid to the box
   */
  boxItem: PropTypes.objectOf(PropTypes.any),
  /**
   * showShortMonths
   */
  showShortMonths: PropTypes.bool,
  /**
   * Define the initial month
   */
  fromMonth: PropTypes.instanceOf(Date),
  /**
   * Render year before Month
   */
  showYearBeforeMonth: PropTypes.bool,
  /**
   * Show year atom
   */
  showYear: PropTypes.bool,
  /**
   * show months atom
   */
  showMonth: PropTypes.bool
};
MonthNavigationTabs.defaultProps = {
  months: 3,
  onSelect: () => {},
  currentMonth: dayjs().toDate(),
  month: {
    fontSize: '5',
    textTransform: 'uppercase'
  },
  year: {
    fontSize: '3'
  },
  currentMonthSettings: { borderColor: 'secondary', textColor: 'secondary', fontWeight: 'bold' },
  colMonthSettings: { padding: '1', cursor: 'pointer' },
  boxItem: {
    width: '100',
    rounded: '0',
    borderBottom: true,
    borderWidth: '3',
    textAlign: 'center',
    paddingHeight: '2',
    tabIndex: 0,
    focusable: true
  },
  showShortMonths: false,
  fromMonth: dayjs().toDate(),
  showYearBeforeMonth: true,
  showYear: true,
  showMonth: true
};

MonthNavigationTabs.componentName = 'MonthNavigationTabs';

export default MonthNavigationTabs;
